/* eslint-disable max-len */
// Full-colour Zoom mark: like AtlassianIcon, it never inherits currentColor — the blue disc
// keeps the white camera legible on both light and dark surfaces.
export const ZoomIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 48 48" fill="none">
            <g transform="translate(1.341 1.553) scale(0.21176)">
                <circle cx="107" cy="106" r="102" fill="#E5E5E4" />
                <circle cx="107" cy="106" r="100" fill="#FFFFFF" />
                <circle cx="107" cy="106" r="92" fill="#4A8CFF" />
                <path fill="#FFFFFF" fillRule="evenodd" d="M135 94.06l26-19c2.27-1.85 4-1.42 4 2V135c0 3.84-2.16 3.4-4 2l-26-19zM47 77.2v43.2A17.69 17.69 0 0 0 64.77 138h63a3.22 3.22 0 0 0 3.23-3.2V91.6A17.69 17.69 0 0 0 113.23 74h-63A3.22 3.22 0 0 0 47 77.2z" />
            </g>
        </svg>
    );
};
